<div class="content_token">
	<h3>{{ shippingWay === '3' ? 'Ingresar coordenada ' + cardCoordinate : 'Ingresar Token' }}</h3>
	<ng-container *ngIf="shippingWay !== '3'">
		<h4 *ngIf="shippingWay === '1'; else emailHeader">
			<!-- se revierte cambio -->
			Enviado al <strong>+51 {{ phone }} </strong>
		</h4>
	</ng-container>

	<ng-template #emailHeader>
		<h4>
			Enviado a <strong> {{ email }} </strong>
		</h4>
	</ng-template>

	<div>
		<div class="codigo_token">
			<ng-container *ngFor="let item of formArray.controls; let i = index">
				<input
					[formControl]="$any(formArray.controls[i])"
					type="number"
					min="0"
					max="9"
					(keydown)="keyDown(item, $event)"
				/>
			</ng-container>
		</div>
	</div>

	<div class="acciones_enviar_token">
		<a class="volver_enviar" (click)="clickResend()">Volver a Enviar</a><br />
		<a class="enviar_correo" (click)="clickValidate()"
			>Enviar a {{ shippingWay === '1' || shippingWay === '3' ? email : '+51 ' + phone }}
		</a>
	</div>
</div>
